export default "__VITE_ASSET__Cq_Eb3Or__"